export default __webpack_public_path__ + "5f42b58a051d8a63afbf1c32b76f772d.png";